import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from '../services/environment.service';
import { RoutePaths } from '@nx-customer-apps/shared/enums';

@Injectable({
    providedIn: 'root'
})
export class DevGuardService {
    private environmentService = inject(EnvironmentService);
    private router = inject(Router);

    canActivate(): boolean {
        if (this.environmentService.production) {
            this.router.navigate([RoutePaths.Error404]);
            return false;
        }
        return true;
    }
}
